<template>
    <v-container fill-height class="align-start py-3">
        <loading-overlay :loading="loading"></loading-overlay>

        <v-row class="fill-height align-center">
            <v-col class="text-center" v-if="match && postersBeneficiary">
                <make-payment
                    v-if="showMakePayment"
                    :match="match"
                    :postersBeneficiary="postersBeneficiary"
                    @pay="pay"
                />
            </v-col>
        </v-row>

        <pisErrorDialog
            v-if="showPISErrorDialog && postersBeneficiary"
            :recipientInfo="postersBeneficiary"
        />

    </v-container>
</template>

<script>
import makePayment from './make-payment.vue';
import pisErrorDialog from '../transfers/components/pis-error-dialog.vue';
import KlarnaService from '../../services/KlarnaService';
import PlaidService from '../../services/PlaidService';

export default {
    components: {
        makePayment,
        pisErrorDialog,
    },
    data() {
        return {
            loading: true,
            match: null,
            postersBeneficiary: null,
            showMakePayment: true,
            showPISErrorDialog: false,
        };
    },
    mounted() {
        if (this.$route.query.oauth_state_id) {
            this.continuePlaidPayment();

            this.showMakePayment = false;
        }
        this.load();
    },
    methods: {
        async load() {
            const { id, hash } = this.$route.params;

            try {
                const { data } = await Vue.backendApi().unregisteredPaymentRequest(id, hash).fetch({
                    withRecipientDetails: true,
                });
                const {
                  match,
                  postersBeneficiary,
                } = data;


                Vue.set(this, 'match', match);
                Vue.set(this, 'postersBeneficiary', postersBeneficiary);
            } catch (err) {
                this.$swal({
                    type: 'error',
                    title: 'Error',
                    text: err,
                });
            } finally {
                this.loading = false;
            }
        },
        pay() {
            const {
                provider,
                method,
            } = this.postersBeneficiary;
            const orderId = this.match.order_id;

            if (method === 'SEPA' || method === 'FASTER' ) { // or another PIS
                this.loading = true;
                // Klarna PIS requires back end to initiate payment
                // so need to call an API
                Vue.backendApi().unregisteredPaymentRequest(id, hash).initiatePayment()
                    .then((response) => {
                        this.loading = false;
                        const { data } = response;
                        switch (data.provider) {
                            case 'KLARNA':
                                if (data.method === 'FASTER') {
                                    return this.initiatePlaidPayment(orderId, data); // temporary
                                } else {
                                    return this.initiateKlarnaPayment(orderId, data);
                                }
                                break;
                            case 'PLAID':
                                if (data.method === 'FASTER') {
                                    this.initiatePlaidPayment(orderId, data);
                                } else {
                                    this.redirectToStatus();
                                }
                                break;
                            default:
                                this.redirectToStatus();
                                break;
                        }
                    })
                    .catch((err) => {
                        this.loading = false;
                        this.showPISError();
                    });
            }

            vm.redirectToStatus();
        },
        initiateKlarnaPayment(orderId, data) {
            const vm = this;
            const flowId = data.flow_id;
            const sessionId = data.session_id;
            const clientToken = data.client_token;
            const klarnaService = new KlarnaService({
                autoClose: true,
                hideTransitionOnFlowEnd: true,
                onLoad: () => {
                    this.loading = false;
                },
                onError: (error) => {
                    this.showPISError();
                    this.redirectToStatus();
                },
            });

            vm.loading = true;
            return klarnaService.init()
                .then(() => {
                    klarnaService.startFlow(clientToken, {
                        onFinished() {
                          vm.completeKlarnaPayment(orderId, sessionId, flowId);
                        },
                    });
                })
                .catch((error) => {
                    vm.loading = false;
                    this.showPISError();
                });
        },
        completeKlarnaPayment(orderId, sessionId, flowId) {
          const vm = this;
          vm.loading = true;
          Vue.backendApi().unregisteredPaymentRequest(id, hash)
              .completePayment('KLARNA', {
                  sessionId,
                  flowId
              })
              .then((response) => {
                  vm.loading = false;
                  const { state } = response.data;
                  if(state && state.toUpperCase() === 'FINISHED') {
                    vm.showMakePayment = false;
                    vm.show = false;
                    vm.$swal({
                        type: 'success',
                        title: 'Payment completed successfully',
                        text: '',
                    });
                  } else {
                    vm.$swal({
                        type: 'error',
                        title: 'Transfer error',
                        text: `Transfer status is ${state}. Please try again`,
                    });
                  }

                  vm.redirectToStatus();
              })
              .catch((error) => {
                  vm.loading = false;
                  vm.$swal({
                      type: 'error',
                      title: 'Error checking payment status',
                      text: error.message,
                  });

                  vm.redirectToStatus();
              });
        },
        async initiatePlaidPayment(orderId, data) {

          const onSuccess = () => {
            this.completePlaidPayment(orderId, data.payment_id);
          };

          const onExit = (err, metadata) => {
              console.log('Plaid onExit', err, metadata);
              this.loading = false;
              if (err) {
                  this.showPISError();
              }
              this.redirectToStatus();
          };

          const plaidConfig = {
            onSuccess: onSuccess,
            onExit: onExit,
            token: data.tokenResponse.link_token,
          };

          localStorage.setItem('KOSHI_PLAID_PIS_LINK_TOKEN', plaidConfig.token);
          localStorage.setItem('KOSHI_PLAID_PIS_ORDER_ID', orderId);
          localStorage.setItem('KOSHI_PLAID_PIS_PAYMENT_ID', data.payment_id);

          const plaidService = new PlaidService();
          this.loading = true;

          try {
              await plaidService.init();
              plaidService.create(plaidConfig);
              await plaidService.open();
              this.loading = false;
          } catch (err) {
              this.loading = false;
              this.showPISError();
          }
        },
        completePlaidPayment(orderId, paymentId) {
          const vm = this;
          vm.loading = true;

          Vue.backendApi().unregisteredPaymentRequest(id, hash)
              .completePayment('PLAID', {
                  paymentId,
              })
              .then((response) => {
                  vm.loading = false;
                  const { state } = response.data;
                  vm.showMakePayment = false;
                  vm.show = false;
                  vm.$swal({
                      type: 'success',
                      title: 'Payment completed successfully',
                      text: '',
                  });

                  vm.redirectToStatus();
              })
              .catch((error) => {
                  vm.loading = false;
                  vm.$swal({
                      type: 'error',
                      title: 'Error checking payment status',
                      text: error,
                  });

                  vm.redirectToStatus();
              });
        },
        async continuePlaidPayment() {
            this.loading = true;

            const token = localStorage.getItem('KOSHI_PLAID_PIS_LINK_TOKEN');
            const orderId = localStorage.getItem('KOSHI_PLAID_PIS_ORDER_ID');
            const paymentId = localStorage.getItem('KOSHI_PLAID_PIS_PAYMENT_ID');

            localStorage.removeItem('KOSHI_PLAID_PIS_LINK_TOKEN');
            localStorage.removeItem('KOSHI_PLAID_PIS_ORDER_ID');
            localStorage.removeItem('KOSHI_PLAID_PIS_PAYMENT_ID');

            if (!token || !orderId || !paymentId) {
                this.loading = false;
                this.$router.push({
                    name: 'transfers',
                    query: null,
                });
                return false;
            }

            const onSuccess = (t,metadata) => {
                Vue.backendApi().unregisteredPaymentRequest(id, hash)
                    .completePayment('PLAID', {
                        paymentId,
                    })
                    .then((response) => {
                        this.loading = false;
                        const { state } = response.data;
                        this.$swal({
                            type: 'success',
                            title: 'Payment completed successfully',
                            text: '',
                        });
                    })
                    .catch((error) => {
                        this.loading = false;
                        this.$swal({
                            type: 'error',
                            title: 'Error checking payment status',
                            text: error,
                        });
                    });
            };

            const onExit = (err, metadata) => {
                console.log('Plaid onExit', err, metadata);
                this.loading = false;
                if (err) {
                    this.$swal({
                        type: 'error',
                        title: 'Plaid Error',
                        text: PlaidService.handleError(err),
                    });
                }
            };

            const plaidConfig = {
                token,
                receivedRedirectUri: window.location.href,
                onSuccess,
                onExit,
            };

            const plaidService = new PlaidService();

            try {
                await plaidService.init();
                plaidService.create(plaidConfig);
                await plaidService.open();
            } catch (err) {
                this.loading = false;
                this.$swal({
                    type: 'error',
                    title: 'Plaid error',
                    text: err.message,
                });
            }
        },
        showPISError() {
            this.showPISErrorDialog = true,
            this.showMakePayment = false;
        },
        redirectToStatus() {
            setTimeout(() => {
                this.$router.push({
                    name: 'upr-status',
                    params: {
                        id,
                        hash,
                    },
                });
            }, 1000);
        },
    },
};
</script>
